<template>
    <div class="product__detail">
        <router-link to="/">
            <p>back to home</p>
        </router-link>
        <div v-if="moviesDetail.id">
            <div v-if="moviesDetail.video" class="banniere">
                <video :src="getVideo(moviesDetail.id)" autoplay></video>
            </div>
        <div  class="card__detail">
            <div class="card__detail__left">
            <img :src="getImage(moviesDetail)" alt="">
            </div>
            <div class="card__detail__Right">
                <h2 v-if="moviesDetail.title">{{moviesDetail.title}}</h2>
                <p v-if="moviesDetail.overview">{{moviesDetail.overview}}</p>
                <p>Popularity : {{moviesDetail.popularity}} | Vote Average : {{moviesDetail.vote_average}}/10</p>
                <button  v-if="!isFavorite(product)"  class="btn__favorite" @click="()=>addToCart(product,$route.params.type)"> Ajouter au Favoris </button>
                <button  v-if="isFavorite(product)"  class="btn__favorite isFavorite"> Favoris </button>
                <router-link v-if="isFavorite(product)" to="/cart">
                    <button class="btn__favorite isFavorite goFavorite">  Voir Favoris </button>
                </router-link>
            </div>
        </div>
        <h2 v-if="moviesCredit.length > 0">Credits</h2>
        <Carousel v-if="moviesCredit.length > 0" :arraydata="moviesCredit" :link='false'/>

        <h2  v-if="moviesSimilar.length > 0">Similar Movie</h2>
        <Carousel v-if="moviesSimilar.length > 0" :arraydata="moviesSimilar" :link='true' type="movie"/>
        </div>
        <div v-if="tvDetail.id">
        <div  class="card__detail">
            <div class="card__detail__left">
            <img :src="getImage(tvDetail)" alt="">
            </div>
            <div class="card__detail__Right">
                <h2>{{tvDetail.name}}</h2>
                <p>{{tvDetail.overview}}</p>
                <p>Popularity : {{tvDetail.popularity}} | Vote Average : {{moviesDetail.vote_average}}/10</p>
                <button  v-if="!isFavorite(product)"  class="btn__favorite" @click="()=>addToCart(product,$route.params.type)"> Ajouter au Favoris </button>
                <button  v-if="isFavorite(product)"  class="btn__favorite isFavorite"> Favoris </button>
                <router-link v-if="isFavorite(product)" to="/cart">
                    <button class="btn__favorite isFavorite goFavorite">  Voir Favoris </button>
                </router-link> </div>
            </div>
        <h2 v-if="tvCredit.length > 0" :arraydata="tvCredit">Credits</h2>
        <Carousel v-if="tvCredit.length > 0" :arraydata="tvCredit" :link='false' />

        <h2 v-if="tvSimilar.length > 0">Similar Movie</h2>
        <Carousel v-if="tvSimilar.length > 0" :arraydata="tvSimilar" :link='true'  type="tv"/>
        </div>
    </div>
</template>

<script>
    import Button from "../components/Button";
    import ApiProducts from "../mixins/ApiProducts";
    import {Carousel3d, Slide} from 'vue-carousel-3d';
    import Carousel from "@/components/Carousel";

    export default {
        components: {
            Button,
            Carousel3d,
            Slide,
            Carousel
        },
        data: function () {
            return {
                moviesDetail:[],
                moviesCredit:[],
                moviesSimilar:[],
                tvDetail:[],
                tvCredit:[],
                tvSimilar:[],
                product:{},
                producttv:[]
            }
        },
        mixins:[ApiProducts],
        mounted() {
    
            if(this.$route.params.type ==="movie"){
            this.getMovie(this.$route.params.id)
                .then(data => {
                    if (data) {
                        this.moviesDetail = data
                        this.product=data
                    } else {
                        this.moviesDetail.push(data)
                    }
                }).catch(err => console.log(err));

                this.getMovieCredit(this.$route.params.id)
                    .then(data => {
                        if (data) {
                            this.moviesCredit = data;
                        } else {
                            this.moviesCredit.push(data)
                        }
                    })
                this.getMovieSimilar(this.$route.params.id)
                    .then(data => {
                        if (data) {
                            this.moviesSimilar = data;
                        } else {
                            this.moviesSimilar.push(data)
                        }
                    })
                    .catch(err => console.log(err));
            }else if (this.$route.params.type ==="tv"){
            this.getTv(this.$route.params.id)
                .then(data => {
                    if (data) {
                        this.tvDetail = data
                        this.product = data
                    } else {
                        this.tvDetail.push(data)
                    }
                }).catch(err => console.log(err));

                this.getTvCredit(this.$route.params.id)
                    .then(data => {
                        if (data) {
                            this.tvCredit = data;
                        } else {
                            this.tvCredit.push(data)
                        }
                    })
                this.getTvSimilar(this.$route.params.id)
                    .then(data => {
                        if (data) {
                            this.tvSimilar = data;
                        } else {
                            this.tvSimilar.push(data)
                        }
                    })
                    .catch(err => console.log(err));
                }
        },
        watch:{
            moviesDetail: function(){
                this.getMovie(this.$route.params.id)
                    .then(data => {
                        if (data) {
                            this.moviesDetail = data
                            this.product=data
                        } else {
                            this.moviesDetail.push(data)
                        }
                    }).catch(err => console.log(err));

                this.getMovieCredit(this.$route.params.id)
                    .then(data => {
                        if (data) {
                            this.moviesCredit = data;
                        } else {
                            this.moviesCredit.push(data)
                        }
                    })
                this.getMovieSimilar(this.$route.params.id)
                    .then(data => {
                        if (data) {
                            this.moviesSimilar = data;
                        } else {
                            this.moviesSimilar.push(data)
                        }
                    })
                    .catch(err => console.log(err));
            },
            tvDetail: function () {
                this.getTv(this.$route.params.id)
                    .then(data => {
                        if (data) {
                            this.tvDetail = data
                            this.product = data
                        } else {
                            this.tvDetail.push(data)
                        }
                    }).catch(err => console.log(err));

                this.getTvCredit(this.$route.params.id)
                    .then(data => {
                        if (data) {
                            this.tvCredit = data;
                        } else {
                            this.tvCredit.push(data)
                        }
                    })
                this.getTvSimilar(this.$route.params.id)
                    .then(data => {
                        if (data) {
                            this.tvSimilar = data;
                        } else {
                            this.tvSimilar.push(data)
                        }
                    })
                    .catch(err => console.log(err));
            }


        },
        methods: {
            getImage(data) {
                let url = '/img/logo.png';
                if (data.poster_path) {
                    url = 'https://image.tmdb.org/t/p/w500' + data.poster_path + '?api_key=07b774c956a772a71371e0875cfec69e';
                }
                return url
            },
            getImageProfil(data) {
                let url = '/img/logo.png';
                if (data.profile_path) {
                    url = 'https://image.tmdb.org/t/p/w500' + data.profile_path + '?api_key=07b774c956a772a71371e0875cfec69e';
                }
                return url
            },
            addToCart: function (data,type) {
                console.log(data)
                this.$store.commit('addToCart', {data,type} )
            },
            getVideo(id){
                let url = 'https://image.tmdb.org/movie/' + id + '/videos?api_key=07b774c956a772a71371e0875cfec69e';
                
                return url.results
            },
            isFavorite(data){
                if(this.$store.state.cart.length > 0){
                    let name = data.title ? data.title : data.name;
                    return this.$store.state.cart.some(el=>el.title === name)
                }
            },


        },
    }
</script>

<style lang="scss" scoped>
    .product__detail{
        display: flex;
        flex-direction: column;
        padding: 3%;
        a{
            text-decoration: none;
        }
        .card__detail{
            width: 100%;
            height: auto;
            border-radius: 20px;
            overflow: hidden;
            background-color:#232323;
            box-shadow: 0 3px 4px 0 rgba(0, 0, 0, 0.2), 0 4px 15px 0 rgba(0, 0, 0, 0.19);
            display: flex;
            flex-direction: row;
            @media screen and (max-width: 750px) {
                display: block;
            }
            .card__detail__left{
                width: 30%;
                height: 100%;
                @media screen and (max-width: 750px) {
                    width: 100%;
                }
                img{

                    margin-bottom: -7px;

                    @media screen and (max-width: 750px) {
                        width: 60%;
                        margin: 0 20%;
                    }
                    @media screen and (max-width: 450px) {
                        width: 100%;
                        margin: 0 auto;
                    }
                }
            }
            .card__detail__Right{
                width: 70%;
                height: 100%;
                padding: 5%;
                .btn__favorite{
                    display:block;
                    border:1px solid #fff;
                    border-radius:5px;
                    padding:4px;
                    width:140px;
                    background-color: #232323;
                    color: #fff;
                    position: relative;
                    bottom: 10px;
                    margin: 10px 0  0 0;
                    transition: 0.3s
                }
                .btn__favorite:hover{
                    cursor: pointer;
                    background-color: #fff ;
                    color: #9c0204;
                }
                .isFavorite{
                    border:1px solid green;
                    background-color: green ;
                    color: #fff;
                    display: inline-block;
                    width: 80px;
                    margin-right: 20px;
                    margin-left: 20px;
                }
                .isFavorite:hover{
                    border:1px solid green;
                    background-color: green ;
                    color: #fff;
                    font-size: 13px;
                }
                .goFavorite{
                    border:1px solid #fff;
                    background-color: #232323;
                    color: #fff;
                    width: 140px;
                }
                .btn__delete{

                    border:1px solid #fff;
                    color: #fff;
                    transition: 0.3s
                }
                .btn__delete:hover{

                    background-color: #fff;
                    color: #9c0204;
                }
            }


        }
        img{
            width: 100%;
            max-width: 800px;
            height: auto;
            margin: 0 auto;
        }
        p{
            color: #fff;

        }
        button{
         width: 200px;
            height: 50px;
            margin: 50px auto 100px auto;
        }
        h2{
            color: #fff;
        }
        height: 75vh;
        overflow-x: auto;
    }

    .product__detail::-webkit-scrollbar {
        margin:20px;
        width: 5px;
        background: #888;
        border-radius:10px;
    }
    .product__detail::-webkit-scrollbar-thumb {
        background: #000000;
        border-radius:10px;
    
    }
</style>